import { Injectable } from "@angular/core";
import { CombeniaService } from '../services/CombeniaService/CombeniaService';
import { CombeniaItem } from '../services/CombeniaService/models/CombeniaItem';
import { CombeniaAttribute } from '../services/CombeniaService/models/CombeniaAttribute';
import { env } from '../environments/environment';
import { SERVICES } from '../constants/services';
import { HttpClient } from '@angular/common/http';
import { AppConst } from '../services/CombeniaService/consts/AppConsts';
import { BackendDataService } from '../services/backendDataService/backendDataService';
import { UserModel } from './UserModel';

@Injectable()
export class BrandModel {

  code: string;
  name: string;
  logo: string;
  position: number;
  semiHiddenBrand: boolean;

  constructor(public combenia: CombeniaService, private http: HttpClient, public backend: BackendDataService, public user: UserModel) { }

  request(url, filter) {
    return new Promise((resolve, reject) => {
      let request = this.http
        .post(
          url,
          filter,
          {
            headers: { "Accept": "*/*", "Content-Type": "application/json" }
          },
        )
        .subscribe(
          (success: any) => {
            resolve(success);
          },
          (error: any) => {
            reject(error);
          },
          () => {
            request.unsubscribe();
          }
        );
    });
  }

  getBrandsFromApi(clientSapCode?: string): Promise<any> {

    let userCredential = localStorage.getItem(AppConst.USER_CREDENTIALS);
    let filter: any = {};
    if (userCredential) {
      filter.username = JSON.parse(userCredential).username;
    }
    if (clientSapCode) {
      filter.clientSapCode = clientSapCode;
    }

    return this.backend.request(SERVICES["BRAND"].list, filter).then(async (data: Array<BrandModel>) => {
      if (!this.user.showPOE) {
        data = data.filter((b) => {
          return !b.semiHiddenBrand;
        })
      }
      data.forEach((el) => {
        el.logo = env.imageUrl + el.code + '.png';
      })
      return data.sort((a,b) => {
        return a.position > b.position ? 1 : a.position < b.position ? -1 : 0;
      });
    }).catch((error) => {
      console.log(error);
      return null;
    });
  }

  // getBrands():Promise<any> {
  //     return this.combenia.readEntity("brands", {}).then(
  //         async (brands) => {
  //            await this.loadSkuImages(brands);
  //            localStorage.setItem("brands", JSON.stringify(brands));
  //            return brands;
  //         }
  //     )
  // }

  async loadSkuImages(list): Promise<any> {
    list = list.filter((el) => {
      return el.logo == undefined
    })
    let code = list.map((l) => {
      return l.code
    })
    let res = await this.combenia.getItemsByCriteria({
      types: ['brand'],
      attributes: [{
        name: 'brand',
        in: code
      }]
    });
    let items = <CombeniaItem[]>res;
    items.forEach((item: CombeniaItem) => {
      let brandCode = this.getAttrValue(item, "brand");
      let image: CombeniaAttribute = this.getAttribute(item, "logoSmall");
      if (image) {
        let url = image.value.url;
        // let url=this.documentProvider.getResourceUrl(image); 
        list.forEach((l) => {
          if (l.code == brandCode)
            l.logo = url;
        })
      } else {
        console.log(brandCode)
      }
    })
  }

  getAttrValue(item: CombeniaItem, attrName: string) {
    let finded = this.getAttribute(item, attrName);
    if (!finded)
      return null;
    return finded.value;
  }
  getAttribute(item: CombeniaItem, attrName: string) {
    let finded = item.attributeList.find((a) => {
      return a.name == attrName;
    })
    if (!finded)
      return null;
    return finded;

  }
}